import classNames from 'classnames';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import { CardMedia } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type StyleProps = {
  width?: number | string;
  maxWidth?: number | string;
  height?: number | string;
  maxHeight?: number | string;
};
const useStyles = makeStyles(() => ({
  size_cover: {
    backgroundSize: 'cover',
  },
  size_contain: {
    backgroundSize: 'contain',
  },
  media_square: {
    height: 0,
    paddingTop: '50%',
  },
  media_16x9: {
    height: 0,
    paddingTop: '56.25%',
  },
  height: {
    height: ({ height }: StyleProps) => height,
  },
  width: {
    width: ({ width }: StyleProps) => width,
  },
  maxHeight: {
    maxHeight: ({ maxHeight }: StyleProps) => maxHeight,
  },
  maxWidth: {
    maxWidth: ({ maxWidth }: StyleProps) => maxWidth,
  },
}));

type Props = {
  getImageData: (src: string) => IGatsbyImageData | undefined;
  src: string;
  alt: string;
  ratio?: 'square' | '16:9';
  size?: 'cover' | 'contain';
  isBackground?: boolean;
  options?: {
    width?: number | string;
    height?: number | string;
    maxWidth?: number | string;
    maxHeight?: number | string;
  };
};
export const Image: React.FC<Props> = ({
  getImageData,
  src,
  alt,
  ratio = 'square',
  size = 'cover',
  isBackground = false,
  options: { width, height, maxWidth, maxHeight } = {},
}) => {
  const classes = useStyles({ maxWidth, width, height, maxHeight });

  const image = getImageData(src);

  // Ratio
  let ratioClass = '';
  switch (ratio) {
    case 'square':
      ratioClass = classes.media_square;
      break;
    case '16:9':
      ratioClass = classes.media_16x9;
      break;
  }
  // Size
  let sizeClass = '';
  switch (size) {
    case 'cover':
      sizeClass = classes.size_cover;
      break;
    case 'contain':
      sizeClass = classes.size_contain;
      break;
  }

  return !image ? (
    <span>{/* missing image placeholder */}</span>
  ) : isBackground ? (
    <CardMedia
      className={classNames(ratioClass, sizeClass)}
      image={image.images.fallback?.src}
      title={alt}
    />
  ) : (
    <GatsbyImage
      className={classNames(
        width && classes.width,
        height && classes.height,
        maxWidth && classes.maxWidth,
        maxHeight && classes.maxHeight,
      )}
      image={image}
      alt={alt}
      style={{
        margin: 'auto',
      }}
      imgStyle={{ margin: 'auto', objectFit: 'contain' }}
    />
  );
};
